import { render, staticRenderFns } from "./OsallistujatTable.vue?vue&type=template&id=695d0ed2"
import script from "./OsallistujatTable.vue?vue&type=script&lang=js"
export * from "./OsallistujatTable.vue?vue&type=script&lang=js"
import style0 from "./OsallistujatTable.vue?vue&type=style&index=0&id=695d0ed2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports